import { render, staticRenderFns } from "./CreateRichmenu.vue?vue&type=template&id=c396c34c&scoped=true&"
import script from "./CreateRichmenu.vue?vue&type=script&lang=js&"
export * from "./CreateRichmenu.vue?vue&type=script&lang=js&"
import style0 from "./CreateRichmenu.vue?vue&type=style&index=0&id=c396c34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c396c34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
